/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
};

type ReturnTuple = [
  vp.CreditNotesResponse | undefined,
  (params: vp.CreditNotesBillsRequest) => void,
  (params: vp.CreditNotesBillsRequest) => Promise<vp.CreditNotesResponse>,
  () => void,
];

function useFetchRailzBillCreditNotes({ api }: HookProps): ReturnTuple {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<vp.CreditNotesBillsRequest>();
  const [response, setResponse] = useState<vp.CreditNotesResponse>();
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async (requestParams: vp.CreditNotesBillsRequest) => {
      setDataFetchingInfo(true, 'loading some data', 'fullScreen');

      const res = await api.fetchRailzBillCreditNotes(requestParams, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest(params);

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (requestParams: vp.CreditNotesBillsRequest) => {
      setParams(requestParams);
      setSendRequest(true);
    },
    (requestParams: vp.CreditNotesBillsRequest) => api.fetchRailzBillCreditNotes(requestParams, source),
    () => {
      setResponse(undefined);
      setSendRequest(false);
    },
  ];
}

export default vopayApi.withApiHook<HookProps, ReturnTuple>(useFetchRailzBillCreditNotes);
